export enum CouponDistribution{
    DistributionPercent,
    FixedNumber
}